import { GET_DEFAULT_MEDIA, GET_MEDIA, SAVE_DEFAULT_MEDIA, SAVE_MEDIA_NAME, SAVE_MEDIA_DATES, SAVE_MEDIA, LOAD_ACTIVE_MEDIA, GET_CRITERIA, DELETE_MEDIA } from '../actions.type'
import { SET_DEFAULT_MEDIA, SET_MEDIA, SET_NEW_UPLOAD_KEY, SET_NEW_UPLOAD_IMAGE, SET_PLATFORM, TOGGLE_TAGS_CHECKED, SET_MEDIA_NAME, SET_MEDIA_DATES, SET_UPLOAD_TAGS, SET_SCREEN_STATE, SET_DETAILS, SET_ACTIVE_MEDIA_ID, RESET_ACTIVE_MEDIA, SET_ACTIVE_MEDIA, SET_CRITERIA, SET_CRITERIA_LOADED, SET_PARTNERS, SET_TAG_VALUES, REMOVE_MEDIA_ITEM, LOAD_DEFAULT_MEDIA, SET_COUNTRY } from '../mutations.type'
import MediaService from '@/services/MediaService'
import SkyService from '@/services/SkyService'
import Vue from 'vue'
import moment from 'moment-timezone'

const state = {
  country: 'USA',
  activeMediaID: null,
  platform: 20,
  platforms: {
    20: 'HMI'
  },
  defaultMedia: {},
  media: {},
  mediaList: [],
  screens: {
    'en': {
      '130-00-CMS (Screensaver)-4x3': {
        id: '130-00-CMS (Screensaver)-4x3',
        type: '130-00-CMS (Screensaver)',
        screen: '4x3',
        screenWidth: 1024,
        screenHeight: 768,
        width: 1024,
        height: 768,
        offsetTop: 0,
        offsetLeft: 0,
        previewSrc: require('@/assets/images/screens/130-00-CMS 4_3.png'),
        backgroundColor: '#fff'
      },
      '130-00-CMS (Screensaver)-16x9': {
        id: '130-00-CMS (Screensaver)-16x9',
        type: '130-00-CMS (Screensaver)',
        screen: '16x9',
        screenWidth: 1366,
        screenHeight: 768,
        width: 1366,
        height: 768,
        offsetTop: 0,
        offsetLeft: 0,
        previewSrc: require('@/assets/images/screens/130-00-CMS 16_9.png'),
        backgroundColor: '#fff'
      },
      '130-50M-CMS (Present Payment (member))-4x3': {
        id: '130-50M-CMS (Present Payment (member))-4x3',
        type: '130-50M-CMS (Present Payment (member))',
        screen: '4x3',
        screenWidth: 1024,
        screenHeight: 768,
        width: 433,
        height: 220,
        offsetTop: 393,
        offsetLeft: 64,
        previewSrc: require('@/assets/images/screens/130-50M-CMS 4_3.png'),
        backgroundColor: '#fff'
      },
      '130-50M-CMS (Present Payment (member))-16x9': {
        id: '130-50M-CMS (Present Payment (member))-16x9',
        type: '130-50M-CMS (Present Payment (member))',
        screen: '16x9',
        screenWidth: 1366,
        screenHeight: 768,
        width: 621,
        height: 220,
        offsetTop: 393,
        offsetLeft: 89,
        previewSrc: require('@/assets/images/screens/130-50M-CMS 16_9.png'),
        backgroundColor: '#fff'
      },
      '170-10-CMS (Show Price)-4x3': {
        id: '170-10-CMS (Show Price)-4x3',
        type: '170-10-CMS (Show Price)',
        screen: '4x3',
        screenWidth: 1024,
        screenHeight: 768,
        width: 414,
        height: 562,
        offsetTop: 80,
        offsetLeft: 585,
        previewSrc: require('@/assets/images/screens/170-10-CMS 4_3.png'),
        backgroundColor: '#152762'
      },
      '170-10-CMS (Show Price)-16x9': {
        id: '170-10-CMS (Show Price)-16x9',
        type: '170-10-CMS (Show Price)',
        screen: '16x9',
        screenWidth: 1366,
        screenHeight: 768,
        width: 512,
        height: 559,
        offsetTop: 80,
        offsetLeft: 831,
        previewSrc: require('@/assets/images/screens/170-10-CMS 16_9.png'),
        backgroundColor: '#152762'
      },
      '170-170-CMS (Thank You)-4x3': {
        id: '170-170-CMS (Thank You)-4x3',
        type: '170-170-CMS (Thank You)',
        screen: '4x3',
        screenWidth: 1024,
        screenHeight: 768,
        width: 407,
        height: 96,
        offsetTop: 506,
        offsetLeft: 75,
        previewSrc: require('@/assets/images/screens/170-170-CMS 4_3.png'),
        backgroundColor: '#fff'
      },
      '170-170-CMS (Thank You)-16x9': {
        id: '170-170-CMS (Thank You)-16x9',
        type: '170-170-CMS (Thank You)',
        screen: '16x9',
        screenWidth: 1366,
        screenHeight: 768,
        width: 566,
        height: 96,
        offsetTop: 506,
        offsetLeft: 90,
        previewSrc: require('@/assets/images/screens/170-170-CMS 16_9.png'),
        backgroundColor: '#fff'
      }
    },
    'fr': {
      '130-00-CMS (Screensaver)-4x3': {
        id: '130-00-CMS (Screensaver)-4x3',
        type: '130-00-CMS (Screensaver)',
        screen: '4x3',
        screenWidth: 1024,
        screenHeight: 768,
        width: 1024,
        height: 768,
        offsetTop: 0,
        offsetLeft: 0,
        previewSrc: require('@/assets/images/screens/130-00-CMS 4_3.png'),
        backgroundColor: '#fff'
      },
      '130-00-CMS (Screensaver)-16x9': {
        id: '130-00-CMS (Screensaver)-16x9',
        type: '130-00-CMS (Screensaver)',
        screen: '16x9',
        screenWidth: 1366,
        screenHeight: 768,
        width: 1366,
        height: 768,
        offsetTop: 0,
        offsetLeft: 0,
        previewSrc: require('@/assets/images/screens/130-00-CMS 16_9.png'),
        backgroundColor: '#fff'
      },
      '130-50M-CMS (Present Payment (member))-4x3': {
        id: '130-50M-CMS (Present Payment (member))-4x3',
        type: '130-50M-CMS (Present Payment (member))',
        screen: '4x3',
        screenWidth: 1024,
        screenHeight: 768,
        width: 433,
        height: 220,
        offsetTop: 393,
        offsetLeft: 64,
        previewSrc: require('@/assets/images/screens/130-50M-CMS 4_3.png'),
        backgroundColor: '#fff'
      },
      '130-50M-CMS (Present Payment (member))-16x9': {
        id: '130-50M-CMS (Present Payment (member))-16x9',
        type: '130-50M-CMS (Present Payment (member))',
        screen: '16x9',
        screenWidth: 1366,
        screenHeight: 768,
        width: 621,
        height: 220,
        offsetTop: 393,
        offsetLeft: 89,
        previewSrc: require('@/assets/images/screens/130-50M-CMS 16_9.png'),
        backgroundColor: '#fff'
      },
      '170-10-CMS (Show Price)-4x3': {
        id: '170-10-CMS (Show Price)-4x3',
        type: '170-10-CMS (Show Price)',
        screen: '4x3',
        screenWidth: 1024,
        screenHeight: 768,
        width: 414,
        height: 562,
        offsetTop: 80,
        offsetLeft: 585,
        previewSrc: require('@/assets/images/screens/170-10-CMS 4_3.png'),
        backgroundColor: '#152762'
      },
      '170-10-CMS (Show Price)-16x9': {
        id: '170-10-CMS (Show Price)-16x9',
        type: '170-10-CMS (Show Price)',
        screen: '16x9',
        screenWidth: 1366,
        screenHeight: 768,
        width: 512,
        height: 559,
        offsetTop: 80,
        offsetLeft: 831,
        previewSrc: require('@/assets/images/screens/170-10-CMS 16_9.png'),
        backgroundColor: '#152762'
      },
      '170-170-CMS (Thank You)-4x3': {
        id: '170-170-CMS (Thank You)-4x3',
        type: '170-170-CMS (Thank You)',
        screen: '4x3',
        screenWidth: 1024,
        screenHeight: 768,
        width: 407,
        height: 96,
        offsetTop: 506,
        offsetLeft: 75,
        previewSrc: require('@/assets/images/screens/170-170-CMS 4_3.png'),
        backgroundColor: '#fff'
      },
      '170-170-CMS (Thank You)-16x9': {
        id: '170-170-CMS (Thank You)-16x9',
        type: '170-170-CMS (Thank You)',
        screen: '16x9',
        screenWidth: 1366,
        screenHeight: 768,
        width: 566,
        height: 96,
        offsetTop: 506,
        offsetLeft: 90,
        previewSrc: require('@/assets/images/screens/170-170-CMS 16_9.png'),
        backgroundColor: '#fff'
      }
    },
  },
  screen1EnList: ['130-00-CMS (Screensaver)-4x3', '130-00-CMS (Screensaver)-16x9'],
  screen2EnList: ['130-50M-CMS (Present Payment (member))-4x3', '130-50M-CMS (Present Payment (member))-16x9'],
  screen3EnList: ['170-10-CMS (Show Price)-4x3', '170-10-CMS (Show Price)-16x9'],
  screen4EnList: ['170-170-CMS (Thank You)-4x3', '170-170-CMS (Thank You)-16x9'],
  screen1FrList: ['130-00-CMS (Screensaver)-4x3', '130-00-CMS (Screensaver)-16x9'],
  screen2FrList: ['130-50M-CMS (Present Payment (member))-4x3', '130-50M-CMS (Present Payment (member))-16x9'],
  screen3FrList: ['170-10-CMS (Show Price)-4x3', '170-10-CMS (Show Price)-16x9'],
  screen4FrList: ['170-170-CMS (Thank You)-4x3', '170-170-CMS (Thank You)-16x9'],

  screen1EnChecked: false,
  screen2EnChecked: false,
  screen3EnChecked: false,
  screen4EnChecked: false,
  screen1FrChecked: false,
  screen2FrChecked: false,
  screen3FrChecked: false,
  screen4FrChecked: false,

  criteriaLoaded: false,
  sitehost: {},
  state: {},
  zip: {},
  stationId: {},
  chargerId: {},
  utility: {},
  subscriptionPlan: {},

  tags: {
    'sitehost': {
      id: 'sitehost',
      label: 'Site Host',
      checked: false,
      single: true,
      saveKey: 'enterpriseId',
      byKey: 'byEnterpriseId',
      type: 'partner',
    },
    'utility': {
      id: 'utility',
      label: 'Utility',
      checked: false,
      options: ['DTE'],
      single: true
    },
    // 'partners': {
    //   id: 'partners',
    //   label: 'Partner Program',
    //   checked: false,
    //   single: true,
    //   saveKey: 'partnerId',
    //   byKey: 'byPartnerId',
    //   type: 'partner',
    // },
    'subscriptionPlan': {
      id: 'subscriptionPlan',
      label: 'Subscription Plan',
      checked: false,
      single: true,
      saveKey: 'subscriptionPlan',
      byKey: 'bySubscriptionPlan',
      type: 'partner',
    },
    'state': {
      id: 'state',
      label: 'State/Province',
      checked: false,
      type: 'location',
      saveKey: 'stateCode',
      byKey: 'byStateCode',
    },
    'zip': {
      id: 'zip',
      label: 'Zip/Postal Code',
      checked: false,
      type: 'location',
      saveKey: 'zipCode',
      byKey: 'byZipCode'
    },
    'stationId': {
      id: 'stationId',
      label: 'Station ID',
      checked: false,
      type: 'location',
      saveKey: 'locationId',
      byKey: 'byLocationId'
    },
    'chargerId': {
      id: 'chargerId',
      label: 'Charger ID',
      checked: false,
      type: 'location',
      saveKey: 'evseId',
      byKey: 'byEvseId'
    }
  },
  tagList: ['sitehost', 'subscriptionPlan', 'state', 'zip', 'stationId', 'chargerId', 'utility'],

  name: '',
  liveDate: null,
  expirationDate: null,
  expirationDateSelected: null,
  duration: null,
  cost: null,
  comments: null
}

const getters = {
  platform: state => state.platforms[state.platform],
  sitehost: state => Object.keys(state.sitehost).map(id => state.sitehost[id]).sort((a, b) => {
    const aName = a.name.toLowerCase()
    const bName = b.name.toLowerCase()
    if (aName < bName) return -1
    else if (aName > bName) return 1
    return 0
  }),
  state: state => Object.keys(state.state).map(id => state.state[id]).sort((a, b) => {
    const aName = a.name.toLowerCase()
    const bName = b.name.toLowerCase()
    if (aName < bName) return -1
    else if (aName > bName) return 1
    return 0
  }),
  zip: state => Object.keys(state.zip).map(id => state.zip[id]).sort((a, b) => {
    if (a.name < b.name) return -1
    else if (a.name > b.name) return 1
    return 0
  }),
  stationId: state => Object.keys(state.stationId).map(id => state.stationId[id]).sort((a, b) => {
    const aName = a.name.toLowerCase()
    const bName = b.name.toLowerCase()
    if (aName < bName) return -1
    else if (aName > bName) return 1
    return 0
  }),
  chargerId: state => Object.keys(state.chargerId).map(id => state.chargerId[id]).sort((a, b) => {
    const aName = a.name.toLowerCase()
    const bName = b.name.toLowerCase()
    if (aName < bName) return -1
    else if (aName > bName) return 1
    return 0
  }),
  subscriptionPlan: state => Object.keys(state.subscriptionPlan).map(id => state.subscriptionPlan[id]).sort((a, b) => {
    if (!a.subscriptionPlanName) return 1
    if (!b.subscriptionPlanName) return -1
    const aName = a.subscriptionPlanName.toLowerCase()
    const bName = b.subscriptionPlanName.toLowerCase()
    if (aName < bName) return -1
    else if (aName > bName) return 1
    return 0
  }),
  screen1En: state => state.screen1EnList.map(id => state.screens.en[id]),
  screen2En: state => state.screen2EnList.map(id => state.screens.en[id]),
  screen3En: state => state.screen3EnList.map(id => state.screens.en[id]),
  screen4En: state => state.screen4EnList.map(id => state.screens.en[id]),
  screen1Fr: state => state.screen1FrList.map(id => state.screens.fr[id]),
  screen2Fr: state => state.screen2FrList.map(id => state.screens.fr[id]),
  screen3Fr: state => state.screen3FrList.map(id => state.screens.fr[id]),
  screen4Fr: state => state.screen4FrList.map(id => state.screens.fr[id]),
  tags: (state, getters) => {
    return state.tagList.map(id => {
      if (getters[id]) {
        return Object.assign({}, state.tags[id], { options: getters[id] })
      }
      return state.tags[id]
    })
  },
  media: state => state.mediaList.map(id => state.media[id])
}

function setupTagValues(state, rootState, commit) {
  const tagValues = []
  for (const tag in state.tags) {
    if (state.tags.hasOwnProperty(tag) && state.hasOwnProperty(tag)) {
      if (state.tags[tag].hasOwnProperty('valueId')) {
        if (Array.isArray(state.tags[tag].valueId)) {
          const toUpdate = { tag }
          toUpdate.value = state.tags[tag].valueId.map(valueId => Object.assign({}, state[tag][`${state.country}-${valueId}`]))
          tagValues.push(toUpdate)
        } else if (tag === 'subscriptionPlan' && state.tags[tag].valueId) {
          tagValues.push({ tag, value: state.tags[tag].valueId });
        } else if (state[tag].hasOwnProperty(state.tags[tag].valueId)) {
          const toUpdate = { tag }
          toUpdate.value = Object.assign({}, state[tag][state.tags[tag].valueId])
          tagValues.push(toUpdate)
        }
      }
    } else if (tag === 'partners' && rootState.partners.partnerData.hasOwnProperty(state.tags[tag].valueId)) {
      const toUpdate = { tag }
      toUpdate.value = Object.assign({}, rootState.partners.partnerData[state.tags[tag].valueId])
      tagValues.push(toUpdate)
    }
  }
  commit(SET_TAG_VALUES, tagValues)
}

const actions = {
  [GET_DEFAULT_MEDIA]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      MediaService.getDefaultMedia()
        .then(response => {
          if (response.data) {
            if (response.data.error) {
              reject(response.data.error)
            } else if (response.data.data) {
              commit(SET_DEFAULT_MEDIA, response.data.data)
              resolve()
            } else {
              reject('NO DATA')
            }
          } else {
            reject('NO RESPONSE')
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [GET_MEDIA]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      MediaService.getMedia()
        .then(response => {
          if (response && response.data) {
            if (response.data.error) {
              reject(response.data.error)
            } else if (response.data.data) {
              commit(SET_MEDIA, response.data.data)
              resolve()
            } else {
              reject('NO DATA')
            }
          } else {
            reject('NO RESPONSE')
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [SAVE_DEFAULT_MEDIA]: ({ state }, country) => {
    const data = {}
    const countryCode = country === 'ca' ? 'CA' : 'US'
    const enData = {}
    for (const id in state.screens.en) {
      if (state.screens.en.hasOwnProperty(id)) {
        const screen = state.screens.en[id];
        if (screen.hasOwnProperty('newKey')) {
          if (!enData.hasOwnProperty(screen.type)) enData[screen.type] = { TOP: {} }
          enData[screen.type].TOP[screen.screen] = screen.newKey
        }
      }
    }
    if (Object.keys(enData).length) {
      data[`en-${countryCode}`] = enData;
    }
    if (country === 'ca') {
      const frData = {}
      for (const id in state.screens.fr) {
        if (state.screens.fr.hasOwnProperty(id)) {
          const screen = state.screens.fr[id];
          if (screen.hasOwnProperty('newKey')) {
            if (!frData.hasOwnProperty(screen.type)) frData[screen.type] = { TOP: {} }
            frData[screen.type].TOP[screen.screen] = screen.newKey
          }
        }
      }
      if (Object.keys(frData).length) {
        data['fr-CA'] = frData;
      }
    }
    if (!Object.keys(data).length) return true;

    return new Promise((resolve, reject) => {
      if (Object.keys(data).length === 0) {
        resolve()
      } else {
        MediaService.uploadDefaultMedia(data)
          .then(response => {
            if (response.data) {
              if (response.data.error) {
                reject(response.data.error)
              } else if (response.data.data) {
                resolve()
              } else {
                reject('NO DATA')
              }
            } else {
              reject('NO RESPONSE')
            }
          })
          .catch(err => {
            reject(err)
          })
      }
    })
  },
  [SAVE_MEDIA_NAME]: ({ commit }, name) => {
    commit(SET_MEDIA_NAME, name)
  },
  [SAVE_MEDIA_DATES]: ({ commit }, dates) => {
    commit(SET_MEDIA_DATES, dates)
  },
  [SAVE_MEDIA]: ({ state, commit }, published) => {
    const saveData = {
      platformId: state.platform
    }
    saveData.published = published
    saveData.country = state.country
    if (state.activeMediaID) saveData.id = state.activeMediaID
    if (state.name) saveData.name = state.name
    if (state.liveDate) saveData.liveDate = moment(state.liveDate).utc().tz('America/Los_Angeles', true).startOf('day').utc().format()
    if (state.expirationDate) saveData.expirationDate = state.expirationDate === Infinity ? Infinity : moment(state.expirationDate).utc().tz('America/Los_Angeles', true).endOf('day').utc().format()
    if (state.expirationDateSelected) saveData.expirationDateSelected = state.expirationDateSelected
    for (const id in state.tags) {
      if (state.tags.hasOwnProperty(id)) {
        const tag = state.tags[id];
        if (tag.byKey) {
          saveData[tag.byKey] = Boolean(tag.checked && tag.byKey)
          if (Array.isArray(tag.value)) {
            saveData[tag.saveKey] = tag.value.map(value => value.subscriptionPlanId || value.id)
          } else if (tag.value) {
            saveData[tag.saveKey] = tag.value.subscriptionPlanId || tag.value.id
          }
        }
      }
    }
    if (state.duration) saveData.duration = state.duration
    if (state.cost) saveData.cost = state.cost
    if (state.comments) saveData.comments = state.comments
    for (const lang in state.screens) {
      if (state.screens.hasOwnProperty(lang)) {
        for (const screenId in state.screens[lang]) {
          if (state.screens[lang].hasOwnProperty(screenId)) {
            const screen = state.screens[lang][screenId];
            if (screen.type && screen.screen && (screen.newKey || screen.image)) {
              if (!saveData.images) saveData.images = {}
              const language = `${lang}-${state.country.substr(0,2)}`
              if (!saveData.images[language]) saveData.images[language] = {}
              if (!saveData.images[language][screen.type]) saveData.images[language][screen.type] = { TOP: {} }
              saveData.images[language][screen.type].TOP[screen.screen] = screen.newKey || screen.image.split('/').splice(4).join('/')
            }
          }
        }
      }
    }

    return new Promise((resolve, reject) => {
      MediaService.saveMedia(saveData)
        .then(response => {
          if (response.data) {
            if (response.data.error) {
              reject(response.data.error)
            } else if (response.data.data) {
              resolve()
              if (response.data.data.id) {
                commit(SET_ACTIVE_MEDIA_ID, response.data.data.id)
              }
            } else {
              reject('NO DATA')
            }
          } else {
            reject('NO RESPONSE')
          }
        })
        .catch(err => {
          if (err && err.response && err.response.status === 403) {
            window.alert('You are not authorized to perform this action')
          }
          reject(err)
        })
    })
  },
  [LOAD_ACTIVE_MEDIA]: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      MediaService.getMedia(id)
        .then(response => {
          if (response.data) {
            if (response.data.error) {
              reject(response.data.error)
            } else if (response.data.data) {
              commit(RESET_ACTIVE_MEDIA)
              commit(SET_ACTIVE_MEDIA, response.data.data[0])
              resolve()
            } else {
              reject('NO DATA')
            }
          } else {
            reject('NO RESPONSE')
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [GET_CRITERIA]: ({ state, rootState, commit }) => {
    return new Promise((resolve, reject) => {
      if (state.criteriaLoaded) {
        setupTagValues(state, rootState, commit)
        resolve()
        return
      }
      const promises = [MediaService.getCriteria(), SkyService.getSkyObjects('subscription-plan')];
      Promise.all(promises)
        .then(([criteria, subscriptionPlans]) => {
          if (criteria.data) {
            if (criteria.data.error) {
              reject(criteria.data.error)
            } else if (criteria.data.data) {
              commit(SET_CRITERIA, criteria.data.data)
              if (criteria.data.data.hasOwnProperty('partner')) {
                commit(SET_PARTNERS, criteria.data.data.partner)
              }
            } else {
              reject('NO DATA')
            }
          }
          if (subscriptionPlans.data) {
            commit(SET_CRITERIA, { subscriptionPlan: subscriptionPlans.data });
          }

          commit(SET_CRITERIA_LOADED)
          setupTagValues(state, rootState, commit)
          resolve()
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [DELETE_MEDIA]: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      MediaService.deleteMedia(id)
        .then(response => {
          if (response.data) {
            if (response.data.error) {
              reject(response.data.error)
            } else if (response.data.data) {
              commit(REMOVE_MEDIA_ITEM, id)
              resolve()
            } else {
              reject('NO DATA')
            }
          } else {
            reject('NO RESPONSE')
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

// basic mutations, showing loading, success, error to reflect the api call status and the token when loaded
const mutations = {
  [SET_COUNTRY]: (state, data) => {
    state.country = data;
  },
  [SET_DEFAULT_MEDIA]: (state, data) => {
    const defaults = {
      'US': {
        id: 'default-us',
        default: true,
        name: 'Default US Media',
        status: 'live',
        country: 'USA',
        images: {}
      },
      'CA': {
        id: 'default-ca',
        default: true,
        name: 'Default CA Media',
        status: 'live',
        country: 'CAN',
        images: {}
      }
    }
    data.forEach(item => {
      const [, country] = item.language.split('-')
      if (!defaults[country].images[item.language]) {
        defaults[country].images[item.language] = {}
      }
      if (!defaults[country].images[item.language][item.screenId]) {
        defaults[country].images[item.language][item.screenId] = {}
      }
      if (!defaults[country].images[item.language][item.screenId][item.size]) {
        defaults[country].images[item.language][item.screenId][item.size] = {}
      }
      defaults[country].images[item.language][item.screenId][item.size] = item.key
    });
    state.defaultMedia = defaults
  },
  [LOAD_DEFAULT_MEDIA]: (state, country) => {
    if (state.defaultMedia[country] && state.defaultMedia[country].images) {
      for (const languageKey in state.defaultMedia[country].images) {
        const [language] = languageKey.split('-')
        if (state.defaultMedia[country].images.hasOwnProperty(languageKey)) {
          const images = state.defaultMedia[country].images[languageKey];
          for (const imageKey in images) {
            if (images.hasOwnProperty(imageKey)) {
              const image = images[imageKey];
              for (const sizeKey in image) {
                if (image.hasOwnProperty(sizeKey)) {
                  const screenKey = `${imageKey}-${sizeKey}`
                  if (state.screens[language].hasOwnProperty(screenKey)) {
                    Vue.delete(state.screens[language][screenKey], 'newKey')
                    Vue.set(state.screens[language][screenKey], 'image', image[sizeKey])
                  }
                  if (state.screen1EnList.indexOf(screenKey) > -1) state.screen1EnChecked = true
                  if (state.screen2EnList.indexOf(screenKey) > -1) state.screen2EnChecked = true
                  if (state.screen3EnList.indexOf(screenKey) > -1) state.screen3EnChecked = true
                  if (state.screen4EnList.indexOf(screenKey) > -1) state.screen4EnChecked = true
                  if (state.screen1FrList.indexOf(screenKey) > -1) state.screen1FrChecked = true
                  if (state.screen2FrList.indexOf(screenKey) > -1) state.screen2FrChecked = true
                  if (state.screen3FrList.indexOf(screenKey) > -1) state.screen3FrChecked = true
                  if (state.screen4FrList.indexOf(screenKey) > -1) state.screen4FrChecked = true
                }
              }
            }
          }
        }
      }
    }
  },
  [SET_MEDIA]: (state, data) => {
    const media = {}
    const mediaList = []
    data.forEach(item => {
      if (!item.name) item.displayName = '[no-name]'
      if (item.liveDate) item.liveDate = moment.tz(item.liveDate, 'America/Los_Angeles').utc(true).toDate()
      if (item.expirationDate) item.expirationDate = moment.tz(item.expirationDate, 'America/Los_Angeles').utc(true).toDate()
      // for (const language in item.images) {
      //   if (item.images.hasOwnProperty(language)) {
      //     for (const screen in item.images[language]) {
      //       if (item.images[language].hasOwnProperty(screen)) {
      //         for (const position in item.images[language][screen]) {
      //           if (item.images[language][screen].hasOwnProperty(position)) {
      //             const screenObject = item.images[language][screen][position];
      //             for (const size in screenObject) {
      //               if (screenObject.hasOwnProperty(size)) {
      //                 const url = screenObject[size];
      //                 screenObject[size] = url
      //               }
      //             }
      //           }
      //         }
      //       }
      //     }
      //   }
      // }
      media[item.id] = item
      mediaList.push(item.id)
    });
    state.media = media
    state.mediaList = mediaList
  },
  [SET_NEW_UPLOAD_KEY]: (state, { id, key, lang }) => {
    if (state.screens[lang][id]) {
      Vue.set(state.screens[lang][id], 'newKey', key)
    }
  },
  [SET_NEW_UPLOAD_IMAGE]: (state, { id, image, lang }) => {
    if (state.screens[lang][id]) {
      if (image) {
        Vue.set(state.screens[lang][id], 'image', image)
      } else {
        Vue.delete(state.screens[lang][id], 'image')
      }
    }
  },
  [SET_PLATFORM]: (state, platform) => {
    if (platform === 'hmi') state.platform = 20
  },
  [TOGGLE_TAGS_CHECKED]: (state, tags) => {
    tags.forEach(tag => {
      if (state.tags.hasOwnProperty(tag.id)) {
        Vue.set(state.tags[tag.id], 'checked', tag.checked)
      }
    });
  },
  [SET_MEDIA_NAME]: (state, name) => {
    state.name = name
  },
  [SET_MEDIA_DATES]: (state, dates) => {
    state.liveDate = dates.live
    state.expirationDate = dates.expiration
    state.expirationDateSelected = dates.expirationSelected
  },
  [SET_UPLOAD_TAGS]: (state, tags) => {
    tags.forEach(tag => {
      if (state.tags.hasOwnProperty(tag.id)) {
        Vue.set(state.tags[tag.id], 'value', tag.value)
      }
    })
  },
  [SET_SCREEN_STATE]: (state, checkedList) => {
    state.screen1EnChecked = checkedList[0]
    state.screen2EnChecked = checkedList[1]
    state.screen3EnChecked = checkedList[2]
    state.screen4EnChecked = checkedList[3]
    state.screen1FrChecked = checkedList[4]
    state.screen2FrChecked = checkedList[5]
    state.screen3FrChecked = checkedList[6]
    state.screen4FrChecked = checkedList[7]
  },
  [SET_DETAILS]: (state, { duration, cost, comments }) => {
    state.duration = duration
    state.cost = cost
    state.comments = comments
  },
  [SET_ACTIVE_MEDIA_ID]: (state, id) => {
    state.activeMediaID = id
  },
  [RESET_ACTIVE_MEDIA]: (state) => {
    state.activeMediaID = null
    state.duration = null
    state.cost = null
    state.comments = null
    state.screen1EnChecked = false
    state.screen2EnChecked = false
    state.screen3EnChecked = false
    state.screen4EnChecked = false
    state.screen1FrChecked = false
    state.screen2FrChecked = false
    state.screen3FrChecked = false
    state.screen4FrChecked = false
    for (const lang in state.screens) {
      if (state.screens.hasOwnProperty(lang)) {
        for (const id in state.screens[lang]) {
          if (state.screens[lang].hasOwnProperty(id)) {
            Vue.delete(state.screens[lang][id], 'newKey')
            Vue.delete(state.screens[lang][id], 'image')
          }
        }
      }
    }
    for (const tag in state.tags) {
      if (state.tags.hasOwnProperty(tag)) {
        Vue.delete(state.tags[tag], 'value')
        Vue.delete(state.tags[tag], 'valueId')
        Vue.set(state.tags[tag], 'checked', false)
      }
    }
    state.liveDate = null
    state.expirationDate = null
    state.expirationDateSelected = null
    state.name = null
    state.platform = 20
    state.country = 'USA'
  },
  [SET_ACTIVE_MEDIA]: (state, media) => {
    if (media.country) state.country = media.country
    if (media.id) state.activeMediaID = media.id
    if (media.duration) state.duration = media.duration
    if (media.cost) state.cost = media.cost
    if (media.comments) state.comments = media.comments
    for (const language in media.images) {
      if (media.images.hasOwnProperty(language)) {
        const lang = language.substr(0, 2)
        for (const imageKey in media.images[language]) {
          if (media.images[language].hasOwnProperty(imageKey)) {
            const image = media.images[language][imageKey];
            for (const position in image) {
              if (image.hasOwnProperty(position)) {
                for (const sizeKey in image[position]) {
                  if (image[position].hasOwnProperty(sizeKey)) {
                    const screenKey = `${imageKey}-${sizeKey}`
                    if (state.screens[lang].hasOwnProperty(screenKey)) {
                      Vue.set(state.screens[lang][screenKey], 'image', image[position][sizeKey])
                    }
                    if (lang === 'en') {
                      if (state.screen1EnList.indexOf(screenKey) > -1) state.screen1EnChecked = true
                      if (state.screen2EnList.indexOf(screenKey) > -1) state.screen2EnChecked = true
                      if (state.screen3EnList.indexOf(screenKey) > -1) state.screen3EnChecked = true
                      if (state.screen4EnList.indexOf(screenKey) > -1) state.screen4EnChecked = true
                    } else if (lang === 'fr') {
                      if (state.screen1FrList.indexOf(screenKey) > -1) state.screen1FrChecked = true
                      if (state.screen2FrList.indexOf(screenKey) > -1) state.screen2FrChecked = true
                      if (state.screen3FrList.indexOf(screenKey) > -1) state.screen3FrChecked = true
                      if (state.screen4FrList.indexOf(screenKey) > -1) state.screen4FrChecked = true
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    for (const tag in state.tags) {
      if (state.tags.hasOwnProperty(tag) && state.tags[tag].hasOwnProperty('saveKey') && media.hasOwnProperty(state.tags[tag].saveKey)) {
        Vue.set(state.tags[tag], 'valueId', media[state.tags[tag].saveKey])
        Vue.set(state.tags[tag], 'checked', Boolean(media[state.tags[tag].byKey]))
      }
    }
    if (media.liveDate) state.liveDate = moment.tz(media.liveDate, 'America/Los_Angeles').utc(true).toDate()
    if (media.expirationDate) state.expirationDate = moment.tz(media.expirationDate, 'America/Los_Angeles').utc(true).toDate()
    if (media.expirationDateSelected) state.expirationDateSelected = media.expirationDateSelected
    if (media.name) state.name = media.name
    if (media.platform) state.platform = media.platform
  },
  [SET_CRITERIA]: (state, criteria) => {
    if (criteria.hasOwnProperty('enterprise')) {
      criteria.sitehost = criteria.enterprise
      delete criteria.enterprise
    }
    if (criteria.hasOwnProperty('zipcode')) {
      criteria.zip = criteria.zipcode
      delete criteria.zipcode
    }
    if (criteria.hasOwnProperty('station')) {
      criteria.stationId = criteria.station
      delete criteria.station
    }
    if (criteria.hasOwnProperty('charger')) {
      criteria.chargerId = criteria.charger
      delete criteria.charger
    }
    state.tagList.forEach(tag => {
      if (criteria.hasOwnProperty(tag)) {
        if (Array.isArray(criteria[tag]) && state.hasOwnProperty(tag)) {
          const options = {}
          criteria[tag].forEach(option => {
            if (option.country) {
              options[`${option.country}-${option.id}`] = option
            } else if (option.unique_id) {
              options[option.unique_id] = option
            } else {
              options[option.id] = option
            }
          })
          state[tag] = options
        }
      }
    })
  },
  [SET_CRITERIA_LOADED]: (state) => {
    state.criteriaLoaded = true
  },
  [SET_TAG_VALUES]: (state, values) => {
    values.forEach(value => {
      if (Array.isArray(value.value)) {
        Vue.set(state.tags[value.tag], 'value', value.value.map(val => Object.assign({}, val)).filter(arr => Object.keys(arr).length))
        Vue.delete(state.tags[value.tag], 'valueId')
      } else if (value.tag === 'subscriptionPlan') {
        const plan = Object.values(state.subscriptionPlan).find(p => p.source === state.country && p.subscriptionPlanId === value.value);
        if (plan) {
          Vue.set(state.tags[value.tag], 'value', plan);
          Vue.delete(state.tags[value.tag], 'valueId')
        }
      } else if (state.tags.hasOwnProperty(value.tag)) {
        Vue.set(state.tags[value.tag], 'value', Object.assign({}, value.value))
        Vue.delete(state.tags[value.tag], 'valueId')
      }
    });
  },
  [REMOVE_MEDIA_ITEM]: (state, id) => {
    const listPos = state.mediaList.indexOf(id)
    if (listPos > -1) {
      state.mediaList.splice(listPos, 1)
      Vue.delete(state.media, id)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
